import Danhmuc from 'api/danhMuc';
import User from 'api/users';

import Reception from 'api/reception';
import LetterProcessing from 'api/letterProcessing';
import LetterProcessingWorkFlow from 'api/letterProcessingWorkFlow';
import Letter from 'api/letter';
import GiaiQuyetDonThu from 'api/giaiQuyetDonThu';
import DuLieuHeThong from 'api/duLieuHeThong';
import TrangChu from 'api/trangChu';
import ThongKeBaoCao from 'api/thongKeBaoCao';
import ThanhTra from 'api/thanhtra';
import TheoDoiGiamSat from 'api/theodoigiamsat';
import QuanLyHoSo from 'api/quanLyHoSo';
import QuanLyVanBan from 'api/quanLyVanBan';
import BaoCaoThanhTra from 'api/baoCaoThanhTra';

export {
  Danhmuc,
  User,
  Reception,
  LetterProcessing,
  LetterProcessingWorkFlow,
  Letter,
  GiaiQuyetDonThu,
  DuLieuHeThong,
  TrangChu,
  ThongKeBaoCao,
  ThanhTra,
  TheoDoiGiamSat,
  QuanLyHoSo,
  QuanLyVanBan,
  BaoCaoThanhTra
};



// WEBPACK FOOTER //
// ./src/api/index.js